var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.customClass')
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "filterable": "",
      "allow-create": "",
      "default-first-option": ""
    },
    model: {
      value: (_vm.optionModel.customClass),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "customClass", $$v)
      },
      expression: "optionModel.customClass"
    }
  }, _vm._l((_vm.cssClassList), function(item, idx) {
    return _c('el-option', {
      key: idx,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.dsEnabled')
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.optionModel.dsEnabled),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "dsEnabled", $$v)
      },
      expression: "optionModel.dsEnabled"
    }
  })], 1), _vm._v(" "), (!!_vm.optionModel.dsEnabled) ? _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.dsName')
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.getDataSetList
    },
    model: {
      value: (_vm.optionModel.dsName),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "dsName", $$v)
      },
      expression: "optionModel.dsName"
    }
  }, _vm._l((_vm.dataSourceList), function(item, idx) {
    return _c('el-option', {
      key: idx,
      attrs: {
        "title": item.description,
        "label": item.uniqueName,
        "value": item.uniqueName
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (!!_vm.optionModel.dsEnabled) ? _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.dataSetName')
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.optionModel.dataSetName),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "dataSetName", $$v)
      },
      expression: "optionModel.dataSetName"
    }
  }, _vm._l((_vm.dataSetList), function(item, idx) {
    return _c('el-option', {
      key: idx,
      attrs: {
        "title": item.remark,
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1) : _vm._e()], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00ff3ef7","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/container-tree/tree-customClass-editor.vue
// module id = null
// module chunks = 